import { ammendChannels } from './TemplateCreator';


const defaultChannelColors = {
  1:[["red","green","blue"]],
  2:[["green"],["green","blue"]],
  3:[["green"],["blue"],["green","blue"]],
  4:[["red"],["green"],["blue"],["red","green","blue"]],
}


function getDefaultChannels(structure){

  let nodes = structure.flat();
  let { length } = nodes;
  let channelOrder = defaultChannelColors[length];


  let output = Object.fromEntries(channelOrder.map((cs,ii) => {

    let key = cs.length > 1 ? "merge" : "colors";
    let value = cs;
    if( key === "merge" ){
      value = nodes.filter((x,ii) => channelOrder[ii].length === 1);
    }

    return ([nodes[ii],{[key]:value}])
  }))



  return output;


}

function getDefaultNodeMappings(structure){

  let nodes = structure.flat()
  let { length } = nodes;
  let channelOrder = defaultChannelColors[length];

  let output = Object.fromEntries(channelOrder.map((cs,ii) => {
    return ([nodes[ii],{channelGroup:nodes[ii]}])
  }));

  ;

  return output;


  //("c"+ii)/*
}

const defaultStructure = [["A","B","C","D"]];




const defaultTemplate = structure => ({
  channelGroupStructure:structure || defaultStructure,

  nodes:getDefaultNodeMappings(defaultStructure),

  channels:getDefaultChannels(defaultStructure),
  regionLocation:"none",
  textLocation:"none",

  regions:[],
  //scalebar



  text:[{ 
    applyAllChannels:{ 
      position:{ base:"tl" }, 
      label:"Label", 
      style:{
        background:"black",
        fontWeight:"bold",
      },
      functions:{ "style.color":"=channelColor" }
    },
  }],
  scalebarLocation:"none",
})

export default function getDefaultMicroscopyTemplate(structure){
  let template = defaultTemplate(structure);
  return template;
}
